import { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'boxes',
        name: 'Talent Box',
        description: 'Visualize your talent with 9-box grids or any two-axis framework built from your review data.',
        descriptionLong: (
            <>
                <p>
                    We're rolling out a new Talent Box view, now available in Early Access. Alongside existing charts
                    and graphs, it maps employees across two axes like potential and performance, or any two numeric
                    measures from your reviews. It supports classic 9-box frameworks, while staying flexible enough to
                    reflect how your organization actually evaluates talent.
                </p>
                <p>
                    If enabled, you will find the boxes in a new tab next to the charts in the performance review
                    overview.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewBoxChart',
        imgSrc: require('./images/talent-boxes.png'),
    },
];
